import { render } from "./perbup.vue?vue&type=template&id=23626fd7&scoped=true"
import script from "./perbup.vue?vue&type=script&lang=js"
export * from "./perbup.vue?vue&type=script&lang=js"

import "./perbup.vue?vue&type=style&index=0&id=23626fd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23626fd7"]])

export default __exports__